// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_2p-1";
export var movingGradient = "_2p-4";
export var movingGradientBlock = "_2p-2";
export var skeleton = "_2p-0";
export var skeletonText = "_2p-3";